import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography, withStyles, CircularProgress, TextField } from '@material-ui/core';
import { Button } from '@lc/legacy/src/Components';
import { useSnackbar } from 'contexts';
import Modal from 'components/Modal';
import clsx from 'clsx';
import api from 'api';
import { useTranslation } from 'react-i18next';

const CouponModal = ({ classes, onClose, roomId }) => {
  const { t } = useTranslation(['common']);
  const [, setMessage] = useSnackbar();
  const [coupon, setCoupon] = useState();
  const [fetching, setFetching] = useState(false);

  const onSubmit = async () => {
    setFetching(true);
    const [res, error] = await api.applyCoupon({code: coupon, hoster_room_id: roomId});
    setFetching(false);
    if (error || !res) {
      setMessage({ message: 'Cupom inválido', variant: 'error' });
    }else {
      setMessage({ message: 'Cupom aplicado', variant: 'info' });
      onClose(res);
    }
  };

  return (
      <Modal 
        onClose={onClose} 
        styleModal={{width: '100%', maxHeight: '300px', borderRadius: '5px', padding: '20px 24px'}} 
        styleBody={{height: '188px'}} 
        maxWidth='330px'
      >
        <Typography variant="h6" component="h6" className={classes.title}>
          Cupom
        </Typography>
        <TextField
          color="secondary"
          label='Inserir um código de cupom'
          value={coupon}
          onKeyPress= {(e) => {
            if (e.key === 'Enter') 
              onSubmit();
            }
          }
          onChange={({ target: { value } }) => {
            setCoupon(value.toUpperCase());
          }}
          className={classes.input}
          inputProps={{ style: { textTransform: "uppercase" } }}
        />
        <Typography color="textPrimary" className={classes.disclaimer}>
          {t('couponDisclaimer')}
        </Typography>
        {fetching ? (
          <div className={clsx(classes.fetchingContainer, classes.buttonMargin)}>
            <CircularProgress color="primary" />
          </div>
        ) : (
          <Button
            fullWidth
            disableTouchRipple
            variant="outlined"
            color="secondary"
            onClick={onSubmit}
            className={classes.buttonMargin}
          >
            Aplicar
          </Button>
        )}
      </Modal>
  );
};

const styles = theme => ({
  title: {
    color: '#383838',
    textAlign: 'center',
    fontSize: '16px'
  },
  input: {
    '& input, & label': {
      fontSize: theme.typography.pxToRem(14),
    },
    '& svg': {
      width: '22px',
      marginRight: theme.spacing(2),
      color: 'hsla(0, 0%, 20%, .5)',
    },
  },
  fetchingContainer: {
    width: '100%',
    height: '60px',
    display: 'flex',
    justifyContent: 'center',
  },
  buttonMargin: {
    marginTop: theme.spacing(3),
  },
  disclaimer: {
    color: '#8b8b8b',
    marginTop: '7px',
    marginLeft: '1px',
    fontSize: '9px'
  }
});

CouponModal.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  roomId: PropTypes.string.isRequired,
};

export default withStyles(styles)(CouponModal);
